import { featuresTypes, zIndexs } from './Options';

import VectorTileLayer from 'ol/layer/VectorTile.js';
import VectorTileSource from 'ol/source/VectorTile.js';
import MVT from 'ol/format/MVT.js';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import { Fill, Text } from 'ol/style';

// Pipes layer
export const layer = new VectorTileLayer({
  name: featuresTypes.PIPES,
  source: new VectorTileSource({
    format: new MVT(),
  }),
  zIndex: zIndexs.pipes,
  opacity: 0.7,
  style: (feature) => {
    const properties = feature.getProperties();
    const { width } = properties;

    const color = properties.cDiam;
    return new Style({
      stroke: new Stroke({
        color: color,
        width: width,
      }),
    })
  },
  // name: 'layerPipes',
  // format: new MVT(),
  // zIndex: zIndexs.pipes,
});

/**
 * 
 * @param {VectorTileSource} newSource 
 * @param {*} props 
 */
export const setSource = (newSource, props, mapComponent) => {
  const map = mapComponent?.state?.map;
  if (!map) {
    return;
  }

  if (!props?.pipesSource) {
    return;
  }

  const pipesSource = props.pipesSource;
  const prevPipesSource = mapComponent.props.pipesSource;

  const newUrl = newSource.getKey().split('?')[0];
  const prevUrl = layer.getSource().getKey().split('?')[0];
  if (newUrl === prevUrl && pipesSource === prevPipesSource) {
    return;
  }
  
  layer.setSource(newSource);

  
  layer.setStyle((feature, a) => {
    const properties = feature.getProperties();
    const { width } = properties;
    
    const color = getColor(properties, pipesSource);
    const length = getRenderedLengthPx(feature.getGeometry(), map);

    let text = '';
    if (length > 75) {
      text = getText(properties, pipesSource); // + `[${length.toFixed()}]`
    }

    return new Style({
    
      stroke: new Stroke({
        color: color,
        width: width,
      }),
      text: new Text({
        text: text, // getText(properties, pipesSource),
        fill: new Fill({ color: '#000000' }),
        stroke: new Stroke({ color: '#ffffff', width: 4 }),
        font: 'bold 12px Calibri,sans-serif',
        textAlign: 'center',
        placement: 'line',
        // overflow: true,
        // declutter: true,
        // declutterMode: 'obstacle',
        // repeat: 500
      })
    })

  })
  layer.declutter = true;

  layer.getSource().on('tileloadend', (evt) => {
    evt.tile.features_.forEach((tile, index) => {
      tile.properties_.type = featuresTypes.PIPES;
      tile.properties_.id = index;
    })
  })

};

export const getLayers = () => {
  return [layer];
};

export const hasFeatures = () => {
  return false;
};

// Clean the layer
export const clear = () => {
};

export const getStyle = (feature, bSelected) => {
  // const properties = feature.getProperties();
  // let color = properties.DiameterColor;
  // let width = 4;
  // return new Style({
  //     stroke: new Stroke({
  //         color: color,
  //         width: width,
  //     }),
  // })
};

export const getInfoTooltip = (feature, map) => {
    const zoom = map.getView().getZoom();

  if (zoom < 16) {
    return null;
  }
  const attr = feature.getProperties();
  return attr;
};

export const tooltipRender = (itemInfo, context, props) => {
  const pipesSource = props.pipesSource;
  const color = getColor(itemInfo, pipesSource);

  return (
    <div className="tooltip-pipe" style={{ border: `solid 2px ${color}`}}>
      {getRow(context.t('material'), itemInfo.vMaterial)}
      {getRow(context.t('diameter'), getText(itemInfo, 'diameter'))}
      {getRow(context.t('year'), getText(itemInfo, 'year') || '--')}
      {/* {getRow(context.t('pressure'), itemInfo.vPres)} */}
    </div>
  );
};

/**
 * 
 * @param {Object} details 
 * @param {'material' | 'pressure' | 'diameter' | 'year' | 'pca' | 'lines'} pipesSource 
 * @returns 
 */
const getText = (details, pipesSource) => {
  switch (pipesSource) {
    case 'material':
      return `${String(details.vMaterial)}    ${String(details.vDiam)}`;
    case 'pressure':
      return String(details.vPres);
    case 'diameter':
      return String(details.vDiam);
    case 'year':      
      return (details.vYear && details.vYear !== -1) ? String(details.vYear) : null;
    case 'pca':
      return String(details.vPca || '')
    case 'lines': 
        return undefined;
    default:
      return '-';
  }
}

const getColor = (details, pipesSource) => {
  switch (pipesSource) {
    case 'material':
      return details.cMaterial;
    case 'pressure':
      return details.cPres;
    case 'diameter':
      return details.cDiam;
    case 'year':
      return details.cYear;
    case 'pca':
      return details.cPca;
    case 'lines':
        return '#0033ff';

    default:
      return '#0088ff';
  }

}

const getRow = (name, value) => (
  <div className='tooltip-pipe-row'>
    <div className='tooltip-pipe-label'>{name}</div>
    <div className='tooltip-pipe-value'>{value}</div>
  </div>
)

const getRenderedLengthPx = (geometry, map) => {
  const flatCoords = geometry.getFlatCoordinates();
  let lengthPx = 0;

  for (let i = 2; i < flatCoords.length; i += 2) {
    const coord1 = [flatCoords[i - 2], flatCoords[i - 1]];
    const coord2 = [flatCoords[i], flatCoords[i + 1]];
    const p1 = map.getPixelFromCoordinate(coord1);
    const p2 = map.getPixelFromCoordinate(coord2);
    const dx = p2[0] - p1[0];
    const dy = p2[1] - p1[1];
    lengthPx += Math.sqrt(dx * dx + dy * dy);
  }

  return lengthPx;
}
